module.exports = __webpack_public_path__ + "static/media/1.caa92517.jpg";